import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectCurrency } from "../../../features/user/userSlice";
import { formatNumber } from "../../../utils/tools";
import { Button, ButtonsContainerRetiro, ErrorSpan, Form, InputContainer } from "../DepositElements";
import monnetpasarelas from '../../../assets/images/chileRetiro1.png';
import perupasarelas from '../../../assets/images/peruRetiro1.png';
import ecuadorpasarelas from '../../../assets/images/ecuadorRetiro1.png';
import RetiraMonnet from '../../../assets/images/RETIRACONMONET-01.svg';


const FormMonnetPeru = ({
  form,
  handleChange,
  handleClose,
  solicitarRetiro,
  loading,
}) => {
  const [t] = useTranslation("global");
  const moneda = useSelector(selectCurrency);
  const [monto, setMonto] = useState(0);
  const [blur, setBlur] = useState(false);

  const handleMonto = (e) => {
    setBlur(true);
    handleChange(formatNumber(e));
    setMonto(parseFloat(e.target.value.replaceAll(".", "").replace(",", ".")));
    if (e.target.value === "") setMonto(0);
  };

  return (
    <Form>
      <InputContainer>
        <label>NOMBRE DEL BANCO:</label>
        <select value={form.bank} onChange={handleChange} name='bank'>
          <option disabled value=''>{t("deposit.lbl-bank")}</option>
          <option value='001 - Banco Continental'>Banco Continental</option>
          <option value='002 - Banco de Credito'>Banco de Credito</option>
          <option value='003 - Interbank'>Interbank</option>
          <option value='004 - Scotiabank'>Scotiabank</option>
          <option value='005 - Banco de Comercio'>Banco de Comercio</option>
          <option value='006 - Banco Interamericano de Finanzas (BanBif)'>Banco Interamericano de Finanzas (BanBif)</option>
          <option value='007 - Banco Pichincha'>Banco Pichincha</option>
          <option value='008 - Citibank'>Citibank</option>
          <option value='011 - Banco GNB'>Banco GNB</option>
          <option value='014 - Banco Santander'>Banco Santander</option>
          <option value='016 - Banco Cencosud'>Banco Cencosud</option>
          <option value='017 - ICBC PERU BANK'>ICBC PERU BANK</option>
          <option value='018 - Banco de la Nación'>Banco de la Nación</option>
          <option value='019 - Caja Arequipa'>Caja Arequipa</option>
          <option value='020 - Caja Cusco'>Caja Cusco</option>
          <option value='021 - Caja Huancayo'>Caja Huancayo</option>
          <option value='022 - Caja Maynas'>Caja Maynas</option>
          <option value='023 - Caja Metropolitana'>Caja Metropolitana</option>
          <option value='024 - Caja Municipal Ica'>Caja Municipal Ica</option>
          <option value='026 - Caja Sullana'>Caja Sullana</option>
          <option value='027 - Caja Tacna'>Caja Tacna</option>
          <option value='028 - Caja Trujillo'>Caja Trujillo</option>
        </select>
      </InputContainer>

      <InputContainer>
        {moneda === 'Sol' ? (
          <label>{t('deposit.Interbank-account-number(CCI)')}:</label>
        ) : (
          <label>{t('deposit.account-number')}:</label>
        )}
        <input
          type='text'
          placeholder={
            moneda === 'Sol'
              ? t('deposit.Interbank-account-number(CCI)')
              : t('deposit.account-number')
          }
          name='bank_account'
          value={form.bank_account}
          onChange={handleChange}
        />
      </InputContainer>
      <InputContainer>
        <label>{t("deposit.documentType")}:</label>
        <select value={form.tipo} onChange={handleChange} name='tipo' >
          <option disabled value=''>{t("deposit.select-document-type")}</option>
            <option value='1'>DNI</option>
            <option value='2'>PAS</option>
            <option value='3'>CE</option>
            <option value='4'>RUC</option>
        </select>
      </InputContainer>
      <InputContainer>
        <label>{t("deposit.id")}</label>
        <input
          type="text"
          placeholder={t("deposit.id")}
          name="cedula"
          value={form.cedula}
          onChange={handleChange}
        />
      </InputContainer>
      <InputContainer>
        <label>{t("deposit.lbl-amount")}</label>
        <input
          type="text"
          placeholder="0,00"
          name="monto"
          value={form.monto}
          onChange={(e) => handleMonto(e)}
        />

        {moneda === 'Sol' && monto < 100 && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} 100 {moneda}{" "}
          </ErrorSpan>
        )}
        {moneda === 'Sol' && monto > 5000 && blur && (
          <ErrorSpan>
            {t("deposit.amount-less-than")} 5.000 {moneda}{" "}
          </ErrorSpan>
        )}

      </InputContainer>
      <img src={RetiraMonnet} alt='RetiraMonnet' className={'tupa1'} style={{width:'40%', marginLeft: '30%', marginTop: '5%'}}/>
      {moneda === 'Sol' && (
        <img src={perupasarelas} alt='Pasarelas Monnet' className={'monnet'} style={{width:'100%', marginTop: '0.5%', marginLeft: '-1%'}}/>
      )}
      <ButtonsContainerRetiro style={{marginTop:'-160px'}}>
        <Button
          onClick={(e) => {
            e.preventDefault();
            handleClose();
          }}
        >
          {t("deposit.btn-cancel")}
        </Button>
        <Button
          primary={true}
          disabled={loading || (monto < 100 && moneda === 'Sol') || (monto > 5000 && moneda === 'Sol')}
          onClick={solicitarRetiro}
        >
          {loading ? t("deposit.loading") : t("deposit.btn-confirm")}
        </Button>
      </ButtonsContainerRetiro>
    </Form>
  );
};

export default FormMonnetPeru;